import React from 'react';

import { Link, useNavigate } from 'react-router-dom';
import * as Styled from './Breadcrumbs.styles';

export type BreadcrumbItem = {
  title: string | React.ReactNode;
  nowrap?: boolean;
  to?: string;
};

export interface BreadcrumbsProps {
  items: BreadcrumbItem[];
}

export function Breadcrumbs({ items, ...rest }: BreadcrumbsProps) {
  return (
    <Styled.Container {...rest}>
      {items.map((item, index) => (
        <Item
          key={index}
          item={item}
          colored={index === items.length - 1 && items.length > 1}
        />
      ))}
    </Styled.Container>
  );
}

function Item({ item, colored }: { item: BreadcrumbItem; colored: boolean }) {
  const navigate = useNavigate();
  const Variant = colored ? Styled.ColoredItem : Styled.Item;

  return (
    <Variant $nowrap={item.nowrap}>
      {item.to ? <Link to={item.to}>{item.title}</Link> : item.title}
    </Variant>
  );
}
